import { IDocumentCategory } from 'types/order/documents/IDocumentCategoryType';
import { IStandardDocumentVersionData } from '../../types/order/documents/shared/interfaces';
import { partition, uniq } from 'lodash';

// ClientPortal has some specific steps for its versioned documents.
// For a given document category, return only the most recent document.
export const clientDocumentSorting = (
  documents: IStandardDocumentVersionData[],
  documentCategoriesByName: Record<string, IDocumentCategory>
): IStandardDocumentVersionData[] => {
  const [repeatableDocuments, nonRepeatableDocuments] = partitionByRepeatable(documents, documentCategoriesByName);
  const categoriesOfNonRepeatableDocs: string[] = uniq(nonRepeatableDocuments.map((doc) => doc.category));
  const sortedVersionedDocuments = nonRepeatableDocuments.sort((documentA, documentB) =>
    (documentB.clientPublishedAt || '').localeCompare(documentA.clientPublishedAt || '')
  );
  const nonRepeatableDocumentsByFirstOnly: IStandardDocumentVersionData[] = categoriesOfNonRepeatableDocs.reduce(
    (accumulated: IStandardDocumentVersionData[], currentCategory) => {
      const first = sortedVersionedDocuments.find((doc) => doc.category === currentCategory);
      return first ? [...accumulated, first] : accumulated;
    },
    []
  );

  return [...repeatableDocuments, ...nonRepeatableDocumentsByFirstOnly].sort(compareByCategoryAndPublished);
};

const partitionByRepeatable = (
  documents: IStandardDocumentVersionData[],
  documentCategoriesByName: Record<string, IDocumentCategory>
): [IStandardDocumentVersionData[], IStandardDocumentVersionData[]] =>
  partition(documents, (doc) => !documentCategoriesByName[doc.category]?.isRepeatable || false);

const compareByCategoryAndPublished = (
  documentA: IStandardDocumentVersionData,
  documentB: IStandardDocumentVersionData
) =>
  `${documentA.category}-${documentA.clientPublishedAt || ''}`.localeCompare(
    `${documentB.category}-${documentB.clientPublishedAt || ''}`
  );
